import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 6742 17428"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g>
      <g id="_1974323951136">
        <path
          d="M1278 3065h4186V620H1278v2445zm4806 621H658V0h5426v3686z"
          className="fil0"
        />
        <path
          d="M1935 2043V902h679v1141zM4128 2043V902h679v1141zM4719 11620H2023V9667h2696z"
          className="fil0"
        />
        <path
          d="M6329 17428c-1916 0-3475-1606-3475-3580v-3063h1034v3063c0 1404 1095 2547 2441 2547v1033zM6328 6738c0-229 185-414 414-415v-590c-229 0-414-185-414-414 0-228 185-414 414-414v-590c-229-1-414-186-414-415 0-228 185-414 414-414v-524H0v524c229 0 414 186 414 414 0 229-185 415-414 415v590c229 0 414 186 414 414 0 229-185 414-414 414v590c229 1 414 186 414 415 0 228-185 413-414 414 5 1857 1512 3362 3371 3362s3365-1505 3370-3362c-228-1-413-186-413-414z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
